var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide"},[_c('img',{attrs:{"src":"https://appd.knowbox.cn/ss/official/download/img/openBrowse3.png","alt":"右上角打开默认浏览器"}})])}]

export { render, staticRenderFns }